import { MenuItem } from "../../../commons/ui/menu";
import { loginMenu } from "./login";

export const routes: MenuItem[] = [
  loginMenu,
];
